import { render, staticRenderFns } from "./TabsSlider.vue?vue&type=template&id=1bcfc0f7&scoped=true"
import script from "./TabsSlider.vue?vue&type=script&lang=js"
export * from "./TabsSlider.vue?vue&type=script&lang=js"
import style0 from "./TabsSlider.vue?vue&type=style&index=0&id=1bcfc0f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcfc0f7",
  null
  
)

export default component.exports